import { EventEmitter } from "events";

import dispatcher from "./dispatcher";
import actionTypes from "./constants";

const CHANGE_EVENT = "change";
let _posts = [];

class publisherStore extends EventEmitter {
  constructor() {
    super();
    dispatcher.register(action => {
      switch (action.actionTypes) {
        case actionTypes.GET_PUBLISHER_DATA:
          _posts = action.posts;
          this.emitChange();
          break;
        default:
      }
    });
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  getPublishers() {
    return _posts;
  }
}

export default new publisherStore();
